import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LandingHeader from "../legacy/components/landingSnapshot/LandingHeader.jsx";
import PublicSiteFooter from "../components/Footer/PublicSiteFooter.jsx";
import useIsMobile from "../hooks/useIsMobile.js";
import HomevilasAssistantWidget from "../components/ai/HomevilasAssistantWidget.jsx";

const MOBILE_PUBLIC_PATHS = [
  /^\/$/,
  /^\/search\/?$/,
  /^\/stays(?:\/.*)?$/,
  /^\/listings(?:\/.*)?$/,
  /^\/property\/[^/]+\/?$/,
  /^\/packages\/?$/,
  /^\/cabs(?:\/.*)?$/,
  /^\/booking(?:\/.*)?$/,
  /^\/payment(?:\/.*)?$/,
  /^\/checkout\/?$/,
  /^\/customer\/login\/?$/,
  /^\/account(?:\/.*)?$/,
  /^\/guest(?:\/.*)?$/,
  /^\/about\/?$/,
  /^\/contact\/?$/,
  /^\/careers\/?$/,
  /^\/help\/?$/,
  /^\/privacy\/?$/,
  /^\/terms\/?$/,
  /^\/partner-with-us\/?$/,
  /^\/b2b-registration\/?$/,
  /^\/blog(?:\/.*)?$/,
  /^\/packages\/.+/,
];

export default function MainLayout() {
  const location = useLocation();
  const isMobile = useIsMobile();
  const useMobileChrome = isMobile && MOBILE_PUBLIC_PATHS.some((pattern) => pattern.test(location.pathname));

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const targets = [
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.getElementById("root"),
    ].filter(Boolean);
    targets.forEach((target) => {
      target.scrollTop = 0;
      target.scrollLeft = 0;
    });
  }, [location.pathname, location.search, location.hash, location.key]);

  return (
    <div className="min-h-screen flex flex-col">
      {useMobileChrome ? null : <LandingHeader />}
      <main className="min-h-screen flex-1">
        <Outlet />
      </main>
      {useMobileChrome ? null : <PublicSiteFooter />}
      <HomevilasAssistantWidget />
    </div>
  );
}
